import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link, MobileStepper } from "@material-ui/core";
import { AppStepperButton } from "../profiler/InputComponents";
import MobileLoading from "../../../components/MobileLoading";
import { repliValidator } from "../../../components";

import useStyles from "../profiler/Profiler.style";
import Cookies from "universal-cookie";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import validator from "validator";
import SaveResultComponent from "./SaveResult.component";

const cookies = new Cookies();

const Bariatrics = () => {
    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };
    const classes = useStyles();


    const [validationError, setValidationError] = useState(false);

    const [loading, setLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [navigationDirection, setNavigationDirection] = useState("");
    const [firstStepSubmitted, setFirstStepSubmitted] = useState(false)
    const [secondStepSubmitted, setSecondStepSubmitted] = useState(false)
    // Bariatrics
    const [hereForBariatricCare, setHereForBariatricCare] = useState('')
    const [hereForBariatricsOrWeightManagement, setHereForBariatricsOrWeightManagement] = useState('')
    const [whatObesityMedicationsTaking, setWhatObesityMedicationsTaking] = useState('')
    const [currentWeight, setCurrentWeight] = useState('')
    const [desiredWeightPriorToPregnency, setDesiredWeightPriorToPregnency] = useState('')
    const [bariatricSurgeryPlanning, setBariatricSurgeryPlanning] = useState('')
    const [typeOfPreviousSurgery, setTypeOfPreviousSurgery] = useState('')
    const [dateOfPreviousSurgery, setDateOfPreviousSurgery] = useState('')
    const [previousStaringWeight, setPreviousStaringWeight] = useState('')
    const [previousCurrentWeight, setPreviousCurrentWeight] = useState('')
    const [previousDesiredWeight, setPreviousDesiredWeight] = useState('')
    const [meetingVitaminGoals, setMeetingVitaminGoals] = useState('')
    const [desireBariatricSurgery, setDesireBariatricSurgery] = useState('')
    const [currentlyEnrolled, setCurrentlyEnrolled] = useState('')
    const [futureCurrentWeight, setFutureCurrentWeight] = useState('')
    const [futureDesiredWeight, setFutureDesiredWeight] = useState('')
    const [submitted, setSubmitted] = useState(false)



    const FirstStepValidator = useRef(
        repliValidator({
            validators: {
                hereForBariatricsOrWeightManagement: {
                    message: "This field is required.",
                    rule: (val, params, validator) => val !== "",
                    required: true,
                },
                hereForBariatricCare:{
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Yes"].includes(params[0])) return val !=="";
                        return true;
                    },
                    required: true,
                }
            },
        })
    );
    const SecondStepValidator = useRef(
        repliValidator({
            validators: {
                whatObesityMedicationsTaking: {
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Weight management"].includes(params[0])) return val !== "";
                        return true;
                    },
                    required: true,
                },
                currentWeight: {
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Weight management"].includes(params[0])) return val > 0;
                        return true;
                    },
                    required: true,
                },
                desiredWeightPriorToPregnency: {
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Weight management"].includes(params[0])) return val > 0;
                        return true;
                    },
                    required: true,
                },
                bariatricSurgeryPlanning: {
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Bariatric surgery"].includes(params[0])) return val !== "";
                        return true;
                    },
                    required: true,
                },
                typeOfPreviousSurgery: {
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Previous surgery"].includes(params[0])) return val !== "";
                        return true;
                    },
                    required: true,
                },
                dateOfPreviousSurgery: {
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Previous surgery"].includes(params[0])) return val !== "";
                        return true;
                    },
                    required: true,
                },
                meetingVitaminGoals: {
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Previous surgery"].includes(params[0])) return val !== "";
                        return true;
                    },
                    required: true,
                },
                desireBariatricSurgery: {
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Future surgery"].includes(params[0])) return val !== "";
                        return true;
                    },
                    required: true,
                },
                currentlyEnrolled: {
                    message: "This field is required.",
                    rule: (val, params, validator) => {
                        if (["Future surgery"].includes(params[0])) return val !== "";
                        return true;
                    },
                    required: true,
                },
                
                previousStaringWeight:{
                    message: 'This field is required',
                    rule: (val, params, validator)=>{
                        if(["Previous surgery"].includes(params[0]))   return val > 0;
                        return true;
                    },
                    required: true
                },
                previousCurrentWeight:{
                    message: 'This field is required',
                    rule: (val, params, validator)=>{
                        if(["Previous surgery"].includes(params[0]))   return val > 0;
                        return true;
                    },
                    required: true
                },
                previousDesiredWeight:{
                    message: 'This field is required',
                    rule: (val, params, validator)=>{
                        if(["Previous surgery"].includes(params[0]))   return val > 0;
                        return true;
                    },
                    required: true
                },
                futureCurrentWeight:{
                    message: 'This field is required',
                    rule: (val, params, validator)=>{
                        if(["Future surgery"].includes(params[0]))   return val > 0;
                        return true;
                    },
                    required: true
                },
                futureDesiredWeight:{
                    message: 'This field is required',
                    rule: (val, params, validator)=>{
                        if(["Future surgery"].includes(params[0]))   return val > 0;
                        return true;
                    },
                    required: true
                },
            },
        })
    );
   


    const totalSteps = hereForBariatricCare ==="Yes" ? 3 : 2;


    useEffect(() => {
        const getHealthProfile = async () => {
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`,
                    {
                        headers: {
                            "X-ACCESS-TOKEN": cookies.get("token"),
                        },
                    }
                );
                if (!response) return;
                let profile = await response.json();
                setHereForBariatricCare(profile.hereForBariatricCare)
                setHereForBariatricsOrWeightManagement(profile.hereForBariatricsOrWeightManagement)
                setWhatObesityMedicationsTaking(profile.whatObesityMedicationsTaking)
                profile.currentWeight ==='undefined' ? setCurrentWeight('') : setCurrentWeight(profile.currentWeight);
                profile.desiredWeightPriorToPregnency === 'undefined' ? setDesiredWeightPriorToPregnency('') : setDesiredWeightPriorToPregnency(profile.desiredWeightPriorToPregnency);
                setBariatricSurgeryPlanning(profile.bariatricSurgeryPlanning)
                setTypeOfPreviousSurgery(profile.typeOfPreviousSurgery)
                setDateOfPreviousSurgery(moment(profile.dateOfPreviousSurgery).utc().format('YYYY-MM-DD'))
                profile.previousStaringWeight === 'undefined' ? setPreviousStaringWeight('') : setPreviousStaringWeight(profile.previousStaringWeight);
                profile.previousCurrentWeight === 'undefined' ? setPreviousCurrentWeight('') : setPreviousCurrentWeight(profile.previousCurrentWeight);
                profile.previousDesiredWeight === 'undefined' ? setPreviousDesiredWeight('') : setPreviousDesiredWeight(profile.previousDesiredWeight);
               setMeetingVitaminGoals(profile.meetingVitaminGoals)
                setDesireBariatricSurgery(profile.desireBariatricSurgery)
                setCurrentlyEnrolled(profile.currentlyEnrolled)
                profile.futureCurrentWeight === 'undefined' ? setFutureCurrentWeight('') : setFutureCurrentWeight(profile.futureCurrentWeight);
                profile.futureDesiredWeight === 'undefined' ? setFutureDesiredWeight('') : setFutureDesiredWeight(profile.futureDesiredWeight);
           
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        getHealthProfile();

    }, []);

    const handleBariatricsOrWeightManagementChange = (value) => {
        setHereForBariatricsOrWeightManagement(value);

        if (value === "Bariatric surgery") {
            setWhatObesityMedicationsTaking("");
            setCurrentWeight('');
            setDesiredWeightPriorToPregnency('')
        }
        if (value === "Weight management") {
            setBariatricSurgeryPlanning('')
            setTypeOfPreviousSurgery('')
            setDateOfPreviousSurgery('')
            setPreviousStaringWeight('')
            setPreviousCurrentWeight('')
            setPreviousDesiredWeight('')
            setMeetingVitaminGoals('')
            setDesireBariatricSurgery('')
            setCurrentlyEnrolled('')
            setFutureCurrentWeight('')
            setFutureDesiredWeight('')
        }
    };
    const handleBariatricSurgeryPlanningChange = (value) => {
        setBariatricSurgeryPlanning(value)
        if (value === 'Previous surgery') {
            setDesireBariatricSurgery('')
            setCurrentlyEnrolled('')
            setFutureCurrentWeight('')
            setFutureDesiredWeight('')
        }
        if (value === 'Future surgery') {
            setTypeOfPreviousSurgery('')
            setDateOfPreviousSurgery('')
            setPreviousStaringWeight('')
            setPreviousCurrentWeight('')
            setWhatObesityMedicationsTaking('')
            setPreviousDesiredWeight('')
            setMeetingVitaminGoals('')
        }
    }
    const handleBariatricCareChange =(e)=>{
        setHereForBariatricCare(e.target.value)
        if (e.target.value === 'No' || e.target.value === 'Unsure') {
            setHereForBariatricsOrWeightManagement('')
            setWhatObesityMedicationsTaking(""); // Clear the field
            setCurrentWeight('');
            setDesiredWeightPriorToPregnency('')
            setBariatricSurgeryPlanning('')
            setTypeOfPreviousSurgery('')
            setDateOfPreviousSurgery('') 
            setPreviousStaringWeight('') 
            setPreviousCurrentWeight('') 
            setPreviousDesiredWeight('')
            setMeetingVitaminGoals('')
            setDesireBariatricSurgery('')
            setCurrentlyEnrolled('')
            setFutureCurrentWeight('')
            setFutureDesiredWeight('')
        }
    }


    const handleBackClick = () => {
        setActiveStep(activeStep - 1);
    };

    const handleSubmit = async () => {
        // e.preventDefault();
        setLoading(true);
        setSubmitted(true)
          // Use the correct validator based on the current step
    const currentValidator = activeStep === 0 ? FirstStepValidator : SecondStepValidator;

    const isValid = currentValidator.current.allValid();
        if(isValid){
             try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_SAVEBARIATRICS}`, {
                method: "POST",
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token'),
                },
                body: new URLSearchParams({
                    hereForBariatricCare: hereForBariatricCare,
                    hereForBariatricsOrWeightManagement: hereForBariatricsOrWeightManagement,
                    whatObesityMedicationsTaking: whatObesityMedicationsTaking,
                    currentWeight: currentWeight,
                    desiredWeightPriorToPregnency: desiredWeightPriorToPregnency,
                    bariatricSurgeryPlanning: bariatricSurgeryPlanning,
                    typeOfPreviousSurgery: typeOfPreviousSurgery,
                    dateOfPreviousSurgery: dateOfPreviousSurgery,
                    previousStaringWeight: previousStaringWeight,
                    previousCurrentWeight: previousCurrentWeight,
                    previousDesiredWeight: previousDesiredWeight,
                    meetingVitaminGoals: meetingVitaminGoals,
                    desireBariatricSurgery: desireBariatricSurgery,
                    currentlyEnrolled: currentlyEnrolled,
                    futureCurrentWeight: futureCurrentWeight,
                    futureDesiredWeight: futureDesiredWeight,
                }),
            });

            // Check for a valid response
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let result = await response.json();
            if (!result) {
                throw new Error("Empty or invalid response");
            }
            setActiveStep(activeStep + 1);

            console.log("Form submitted successfully", result);
        } catch (error) {
            console.error("Error submitting form: ", error.message);
        } finally {
            setLoading(false);
        }
        }
        else{
            setLoading(false)
            currentValidator.current.showMessages();
            return;
        }
       
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        return;
       
    };


    const handleNextClick = () => {
        let validators = [
            { step: 0, validator: FirstStepValidator },
            { step: 1, validator: SecondStepValidator }
        ];
        let activeValidator = validators.find(
            (validator) => validator.step === activeStep
        );
        if (activeValidator) {
            let error = !activeValidator.validator.current.allValid();
            setValidationError(error);
            if (error) {
                activeValidator.validator.current.showMessages();
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
                return;
            }
            validators.forEach((validator) => {
                validator.validator.current.hideMessages();
            });
        }
        setNavigationDirection("forward");
        setActiveStep(activeStep + 1);

    };

    const handleChange = (setter) => (e) => {
        const value = e.target.value;
        const regex = /^\d*\.?\d{0,3}$/; 
        if (value === '' || regex.test(value)) {
            setter(value); 
        } else {
            setter('');
        }
    };
    

    const handleActiveStepReset = (index) => {
        setActiveStep(index);
    };
    if (loading) return <MobileLoading />;

    return (
        <Box className={classes.root}>
            {activeStep === 0 && (
                <FirstStep
                    submitted={submitted}
                    validator={FirstStepValidator.current}
                    error={validationError}
                    hereForBariatricCare= {hereForBariatricCare}
                    setHereForBariatricCare ={e=>handleBariatricCareChange(e)} 
                    firstStepSubmitted={firstStepSubmitted}
                    hereForBariatricsOrWeightManagement={hereForBariatricsOrWeightManagement}
                    setHereForBariatricsOrWeightManagement={setHereForBariatricsOrWeightManagement}
                    handleBariatricsOrWeightManagementChange={e => handleBariatricsOrWeightManagementChange(e)}
                />
            )}
            {activeStep === 1 && (
                <SecondStep
                    submitted={submitted}
                    hereForBariatricsOrWeightManagement={hereForBariatricsOrWeightManagement}
                    hereForBariatricCare= {hereForBariatricCare}
                    validator={SecondStepValidator.current}
                    error={validationError}
                    whatObesityMedicationsTaking={whatObesityMedicationsTaking}
                    setWhatObesityMedicationsTaking={setWhatObesityMedicationsTaking}
                    currentWeight={currentWeight}
                    onCurrentWeightChange={handleChange(setCurrentWeight)}
                    desiredWeightPriorToPregnency={desiredWeightPriorToPregnency}
                    onDesiredWeightPriorToPregnencyChange={handleChange(setDesiredWeightPriorToPregnency)}
                    bariatricSurgeryPlanning={bariatricSurgeryPlanning}
                    handleBariatricSurgeryPlanningChange={(e) => handleBariatricSurgeryPlanningChange(e)}
                    typeOfPreviousSurgery={typeOfPreviousSurgery}
                    setTypeOfPreviousSurgery={setTypeOfPreviousSurgery}
                    dateOfPreviousSurgery={dateOfPreviousSurgery}
                    onDateOfPreviousSurgeryChange={e => setDateOfPreviousSurgery(e.target.value)}
                    previousStaringWeight={previousStaringWeight}
                    onPreviousStaringWeightChange={handleChange(setPreviousStaringWeight)}
                    previousCurrentWeight={previousCurrentWeight}
                    onPreviousCurrentWeightChange={handleChange(setPreviousCurrentWeight)}
                    previousDesiredWeight={previousDesiredWeight}
                    onPreviousDesiredWeightChange={handleChange(setPreviousDesiredWeight)}
                    meetingVitaminGoals={meetingVitaminGoals}
                    setMeetingVitaminGoals={setMeetingVitaminGoals}
                    desireBariatricSurgery={desireBariatricSurgery}
                    setDesireBariatricSurgery={setDesireBariatricSurgery}
                    currentlyEnrolled={currentlyEnrolled}
                    setCurrentlyEnrolled={setCurrentlyEnrolled}
                    futureCurrentWeight={futureCurrentWeight}
                    onFutureCurrentWeightChange={handleChange(setFutureCurrentWeight)}
                    futureDesiredWeight={futureDesiredWeight}
                    onFutureDesiredWeightChange={handleChange(setFutureDesiredWeight)}

                />
            )}
            {
                activeStep === totalSteps-1 && <SaveResultComponent />
            }

            {activeStep !== totalSteps-1 && (
                <Box className={classes.regularFooter}>
                    <MobileStepper
                        variant="dots"
                        steps={totalSteps}
                        position="static"
                        activeStep={activeStep}
                        style={{ backgroundColor: "rgba(0,0,0,0)" }}
                    />


                    {activeStep <= 1 &&
                        <Box style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                           
                                {activeStep === 0 && (
                                    <Box flexGrow={1} pr={1} style={{ width: '50%' }}>
                                        <Link
                                            component={RouterLink}
                                            to="/app/dashboard"
                                            underline="none"
                                        >
                                            <AppStepperButton
                                                variant="contained"
                                                color="secondary"
                                                fullWidth
                                                size="large"
                                                onClick={handleBackClick}
                                                width='50%'
                                            >
                                                Exit
                                            </AppStepperButton>
                                        </Link>
                                    </Box>
                                )}
                          
                            {activeStep > 0 && (
                                <Box flexGrow={1} pr={1} style={{ width: '50%' }}>
                                    <AppStepperButton
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        size="large"
                                        onClick={handleBackClick}
                                        width='50%'
                                    >
                                        Previous
                                    </AppStepperButton>
                                </Box>
                            )}
                            <Box pl={1} style={{ width: '50%' }}>
                                <AppStepperButton
                                    variant="contained"
                                    color="secondary"
                                    fullWidth
                                    size="large"
                                    onClick={activeStep === totalSteps-2   ? handleSubmit : handleNextClick}
                                    width='50%'
                                >
                                    {activeStep === totalSteps-2   ? 'Submit' : 'Continue'}
                                </AppStepperButton>
                            </Box>
                        </Box>
                    }



                </Box>
            )}
        </Box>
    );
};

export default Bariatrics;
